// extracted by mini-css-extract-plugin
module.exports = {"container":"Offers_container__3aUQ9","offers":"Offers_offers__3JLSx"};